// Generated by https://quicktype.io

export interface Tenant {
    id: string;
    trading_group_code: string;
    template: string;
    enabled: number;
    accounts_linked: ObjectLinked[];
    staff_linked: ObjectLinked[];
    gateways_linked: ObjectLinked[];
    platform_linked: ObjectLinked[];
}

export interface ObjectLinked {
    id: string;
}

// export enum CompanyGroup {
//     EIG = 'EIG',
//     BLU = 'BLU',
//     FCS = 'FCS',
//     PAT = 'PAT'
// }

// export enum Role {
//     ADMIN_ALL = 'ADMIN_ALL',
//     ADMIN_EIG = 'ADMIN_EIG',
//     ADMIN_BLU = 'ADMIN_BLU',
//     ADMIN_FCS = 'ADMIN_FCS',
// }

// export enum TenantName {
//     EIG_ASIC = 'EIG_ASIC',
//     EIG_FCA = 'EIG_FCA',
//     EIG_VFSC = 'EIG_VFSC',
//     BLU_ASIC = 'BLU_ASIC',
//     BLU_VFSC = 'BLU_VFSC',
//     FCS_ASIC = 'FCS_ASIC',
//     FCS_VFSC = 'FCS_VFSC',
//     PAT_ASIC = 'PAT_ASIC',
//     PAT_VFSC = 'PAT_VFSC',
// }

// export enum EntityName {
//     ASIC = 'ASIC',
//     VFSC = 'VFSC',
//     SCB = 'SCB',
//     FCA = 'FCA',
//     CYSEC = 'CYSEC',
//     FCS = 'FCS',
//     NONE = 'NONE',
// }
